import { useTranslation } from 'react-i18next';

import ThemedPageHeader from '~/components/PageHeader/ThemedPageHeader';
import useCopyToClipboard from '~/hooks/useCopyToClipboard';
import usePublication from '~/hooks/usePublication';

const ShareOveview = ({ referralLink, referralCount }: any) => {
  const copy = useCopyToClipboard();
  const publication = usePublication();
  const { t } = useTranslation();

  return (
    <div className="mb-4 flex w-full flex-col justify-between space-y-4 border-b border-gray-300 pb-8 sm:flex-row sm:items-center sm:space-y-0">
      <div className="w-full max-w-sm space-y-2">
        <ThemedPageHeader
          title={t('referrals.share.title', { name: publication.name })}
          description={t('referrals.share.description')}
        />
        <div className="flex h-12 w-full">
          <input
            type="email"
            name="email"
            autoComplete="email"
            value={referralLink}
            readOnly
            className="h-full w-full rounded-l-wt border border-r-0 border-gray-200 bg-white px-5 text-sm font-light text-black placeholder-gray-400 outline-0 focus:text-sm"
            placeholder={t('subscribe.email_placeholder') || ''}
            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
            required
          />
          <input
            onSubmit={(e: any) => e.preventDefault()} // Not worth risking any event propagation from this
            onClick={() => copy(referralLink)}
            value={t('shared.cta.copy') || ''}
            type="button"
            className="wt-button-font block h-full w-fit cursor-pointer rounded-r-wt border border-wt-primary bg-wt-primary px-8 text-sm text-white"
          />
        </div>
      </div>
      <div className="mx-auto -mb-2 w-fit sm:mx-0">
        <div className="w-fit rounded-t-md bg-wt-primary px-4 py-2">
          <div className="text-sm text-white">{t('referrals.share.count')}</div>
        </div>
        <div className="flex items-center justify-center rounded-b-md border border-gray-200 py-4 text-4xl font-bold text-gray-900">
          {referralCount}
        </div>
      </div>
    </div>
  );
};

export default ShareOveview;
